import React, { useState, useRef } from "react";
import Lottie from "lottie-react";
import animationData from "./lotties/contact-me.json";
import emailjs from "@emailjs/browser";

export default function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loader, setLoader] = useState(false);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    setLoader(true);
    setName("");
    setEmail("");
    setMessage("");

    e.preventDefault();
    emailjs
      .sendForm(
        "service_f3p1n0k",
        "template_lmg1b8r",
        form.current,
        "N1QFZmx0UHDtm7qCQ"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="container">
      <div className="wrapper">
        <p>Feel free to reach me anytime.</p>

        <div className="flex-container">
          <form
            onSubmit={sendEmail}
            className="contact-form"
            action=""
            ref={form}
          >
            <input
              name="from_name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              type="text"
              className="form-control"
              placeholder="Your Name"
              required
            />

            <input
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              className="form-control"
              placeholder="Your Email"
              required
            />

            <textarea
              name="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="form-control"
              placeholder="Your message goes here!"
              rows="4"
              required
            ></textarea>

            <input
              type="submit"
              className="form-control submit"
              value="Send"
              style={{ backgroundColor: loader ? "#e20001" : "#191919" }}
            />
          </form>

          <Lottie options={defaultOptions} height={400} width={560} />
        </div>
        <div className="social-media-icons">
          <a
            href="https://github.com/IshaanTyagi"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fab fa-github"></i>
          </a>
          <a
            href="https://www.linkedin.com/in/ishaan-tyagi-998228146/"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fab fa-linkedin"></i>
          </a>
          <a
            href="https://www.instagram.com/its_ishaan._/"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fab fa-instagram"></i>
          </a>
        </div>
      </div>
    </div>
  );
}
